export const indexBannerSliderOptions = (instance, options) => {
    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true
        },
        loop: true,
        autoHeight: false,
        effect: 'fade',
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
        },
    }
}